module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "miniloader"
  }, [_c('div', {
    staticClass: "miniloader_cont"
  }, [_c('div', {
    staticClass: "miniloader_spinner"
  }, [_c('div', {
    staticClass: "miniloader_front"
  }), _vm._v(" "), _c('div', {
    staticClass: "miniloader_back"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e607f1ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/miniloader.vue
// module id = 664
// module chunks = 0